import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import 'jspdf-autotable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { DeclRendWebModel } from '../../shared/models/declRendWeb.model';
import { PessoaJuridicaModel } from '../../shared/models/pessoa-juridica.model';
import { PessoaService } from '../../shared/services/pessoa.service';
import { InformacoesIndividuaisDeclaRenda } from './../../shared/dominios/DTO/informacoes-individuais-decla-renda';
import { DeclaracaoRendimentoPdf } from './../../shared/services/documentos-pdf-imprimir/financeiro/declaracao-redimento/declaracao-rendimento-pdf';
import { DeclaracaoRendimentoService } from './service/declaracao-rendimento.service';
import { FinanceiroService } from '../service/financeiro.service';
import { StorafeUtil } from '../../shared/util/storasge.util';
import { CODIGO_CENTRUS } from '../../../app.constants';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PessoaDadosSimplicadosModel } from '../../shared/models/pessoa-simplificada.model';
import { MessageUtil } from '../../shared/messages/messageUtil';
import { AuthInterceptor } from '../../interceptor/auth.interceptor';

@Component({
  selector: 'app-declaracao-rendimento',
  templateUrl: './declaracao-rendimento.component.html',
  styleUrls: ['./declaracao-rendimento.component.css']
})
export class DeclaracaoRendimentoComponent implements OnInit {


  @ViewChild('tabelaPdf') tabelaPdf: ElementRef;

  componentes: any[] = [1];
  anos: any[] = [];

  cdCentrus: number;
  // cdCentrus = 629618;

  versaoRetorno: number;


  testeText: string[];

  informacoesIndividuaisDeclaRenda: InformacoesIndividuaisDeclaRenda = new InformacoesIndividuaisDeclaRenda();

  declRendWebModel = new DeclRendWebModel();

  informacoesComplementoTela = '';


  pessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  exercicioAno: number;
  anoCalendario: number;


  @BlockUI() blockUi: NgBlockUI;


  informacoesComplementares: string[] = [];
  param: string;
  pessoaJuridicaModel: PessoaJuridicaModel = new PessoaJuridicaModel();

  constructor(
    private declaracaoRendimentoService: DeclaracaoRendimentoService,
    private financeiroService: FinanceiroService,
    private declaracaoRendimentoPdf: DeclaracaoRendimentoPdf,
    private authInterceptor: AuthInterceptor,
    private pessoaService: PessoaService,
    private toastrService: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {

    this._gerenciarCodigoIndentificao();
  }


  getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {

        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
          this.param = '/administrativo/operacoesConsultaParticipante';
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
          this.param = '/cardMenus/cardMenuFinanceiro';
        }
        this.getPessoasDadosSimplificado();
        this.getListAnos();
        this.getPessoaJuridica();
      })
  }





  async getListAnos() {

    try {
      const anosRetorno = await this.financeiroService.getListAnos(this.cdCentrus);
      anosRetorno.forEach(element => {
        this.anos.push({ label: element, value: element })
      });
    } catch (error) {
      console.error(error);
    }
  }


  async getPessoasDadosSimplificado() {

    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.getAnoCorrente();
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }

  async getAnoCorrente() {

    try {
      this.anoCalendario = await this.declaracaoRendimentoService.getAnoCorrente(this.cdCentrus);
      this.exercicioAno = (this.anoCalendario + 1)

      this.getObterdecl(this.anoCalendario);
      this.getObterParametrosIrf(this.anoCalendario);
      this.getObterVersao(this.anoCalendario);
    } catch (error) {
      this.toastrService.info('Não foi encontrado declaração rendimento para essa data', 'Não foi encontrado', { timeOut: 8000 })
    }
  }

  getDeclaracaoRendimento(anoCalendario) {
    this.exercicioAno = (anoCalendario + 1)
    this.getObterdecl(anoCalendario);
    this.getObterParametrosIrf(anoCalendario);
    this.getObterVersao(anoCalendario);
  }


  async getObterdecl(ano) {
    try {
      this.declRendWebModel = await this.declaracaoRendimentoService.getObterdecl(this.cdCentrus, ano);
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }

  async getObterVersao(aaVersao) {

    try {
      this.versaoRetorno = await this.declaracaoRendimentoService.getObterVersao(aaVersao);
      this.getObterDeclCompl();
    } catch (error) {
      console.error(error);

    }

  }

  async getObterParametrosIrf(ano) {
    try {
      const responsavelInforamcao = await this.declaracaoRendimentoService.getObterParametrosIrf(ano);
      this.informacoesIndividuaisDeclaRenda.nomeResponsavel = responsavelInforamcao['nome'];
      this.informacoesIndividuaisDeclaRenda.dataRespon = responsavelInforamcao['dataEmissoaDirf'];
    } catch (error) {
      console.error(error);
    }
  }



  async getObterDeclCompl() {
    try {
      const textoRetorno = await this.declaracaoRendimentoService.getObterDeclCompl(this.cdCentrus, this.versaoRetorno);
      this.informacoesComplementoTela = ('\n' + textoRetorno.join('\n'));
    } catch (error) {
      console.error(error);
    }
  }

  async getPessoaJuridica() {
    try {
      this.pessoaJuridicaModel = await this.pessoaService.getPessoaJuridica();
    } catch (error) {
      console.error(error);
    }
  }


  imprimirPagina() {

    this.declaracaoRendimentoPdf.funcionarios(this.pessoaDadosSimplicadosModel, this.declRendWebModel, this.exercicioAno, this.anoCalendario, this.pessoaJuridicaModel,
      this.informacoesIndividuaisDeclaRenda, this.versaoRetorno, this.informacoesComplementoTela);

  }

  direcionar(): void {
    this.router.navigate(['/financeiros/declaracaoRendimento/Detalhe', this.anoCalendario], { skipLocationChange: true })
  }



  voltarForcada(): void {
    this.router.navigate([this.param]);
    this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
  }



}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/declaracao-rendimento/declaracao-rendimento.component.ts